<template>
	<div v-if="food">
		<base-dialog v-if="$store.getters['session/userHasCompanies']" v-model="showFoodDetailsDialog" :dontShowAgainCookie="COOKIE_FOOD_DETAILS_DIALOG" :dontShowAgainCookieExpirationDays="30">
			<p>{{  $t('patient.foods.food-detail-dialog-info') }}</p>
		</base-dialog>
		<BModal v-model="addPatientFoodModalVisible" :title="modalTitle" hide-header hide-footer centered>
			<div class="text-center">
				<base-checkbox v-model="newPatientFood.inDiet" v-if="!foodIsInPatientFoods">{{ $t('patient.foods.diet-question') }}</base-checkbox>
				<div v-if="habitCreationVisible">
					<base-checkbox v-model="newPatientFood.createHabit" v-if="!foodIsInPatientFoods">{{ $t('patient.foods.habits-question') }}</base-checkbox>
					<div v-if="newPatientFood && newPatientFood.createHabit && !newPatientFood.habitId">
						<healthy-habits-form inModal @habitCreated="(habitId) => onNewHabitCreated(habitId)" :habitDescription="$i18nHelpers.normalize(food.name)"/>
					</div>
				</div>
				<div v-if="newPatientFood.habitId">
					<b-alert show variant="success">{{ $t('patient.foods.habit-created-success') }}</b-alert>
				</div>
				<b-button class="mt-4" variant="primary" @click="addPatientFood" v-if="!foodIsInPatientFoods">{{ $t('patient.foods.add-to-my-foods') }}</b-button>
			</div>
		</BModal>
		<BModal v-model="deletePatientFoodModalVisible" hide-header hide-footer centered>
			<div class="text-center">
				<p>{{ $t('patient.foods.remove-from-my-foods-warning') }}</p>
				<base-checkbox v-model="deleteAlsoFromHabits" v-if="foodHasCreatedHabit">{{ $t('patient.foods.remove-from-habits') }}</base-checkbox>
				<b-button variant="danger" @click="deleteFoodFromPatientFoods">{{ $t('patient.foods.delete-food') }}</b-button>
				<b-button v-if="patientFood.inDiet" variant="info" @click="removeFoodFromDiet">{{ $t('patient.foods.remove-from-diet') }}</b-button>
			</div>
		</BModal>
		<b-row>
			<b-col cols="1">
				<b-icon-chevron-left @click="goToSlide(-1)" size="2rem" class="chevron-icons"></b-icon-chevron-left>
			</b-col>
			<b-col cols="10">
				<b-row class="neu-card-food text-center w-100 position-relative" cols="12" cols-xl="12">
					<h3 class="m-auto d-block w-100">{{ $i18nHelpers.normalize(food.name) }}</h3>
					<component :is="bellIconComponentType" v-if="$store.getters['session/userHasCompanies'] && foodIsInPatientFoods" class="position-absolute bell-food" variant="primary" v-b-tooltip.hover="createHabitTooltip" @click="onBellIconClick"></component>
					<!-- <component :is="plusIconComponentType" v-if="foodIsInPatientFoods" variant="primary" class="add-to-diet" @click="onPlusIconClick" v-b-tooltip.hover="plusIconTooltip"/> -->
					<component :is="heartIconComponentType" v-if="$store.getters['session/userHasCompanies']" class="position-absolute heart-food" variant="primary" v-b-tooltip.hover="addToFavoritesTooltip" @click="onHeartIconClick"></component>
					<!-- <BCarousel class="mt-5" id="carousel-food" :interval="5000" fade>
							<BCarouselSlide class="food-slide" v-for="(image, index) in food.images" :key="image" :img-src="image" :alt="`Imagen ${index}`"></BCarouselSlide>
					</BCarousel> -->
					<ImagesTransition :images="food.images" class="mt-5"/>
					<h5 class="mt-5">{{ $i18nHelpers.normalize(getCurrentFoodDescription)}}</h5>
				</b-row>
				<b-row class="pt-3">
					<ArrowButton variant="primary" v-if="$store.getters['session/userHasCompanies']" :action="() => { $router.push({name: 'FavoritesFood'}) }" class="ml-auto" :text="$t('patient.foods.go-to-my-foods')"></ArrowButton>
				</b-row>
			</b-col>
			<b-col cols="1">
				<b-icon-chevron-right @click="goToSlide(1)" class="chevron-icons" size="5rem"></b-icon-chevron-right>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import { BAlert, BBadge, BCarousel, BCarouselSlide, BIconHeart, BIconHeartFill, BModal, BButton, BIconChevronRight, BIconChevronLeft, BIconBell, BIconBellFill, BIconPlusCircle, BIconDashCircle } from 'bootstrap-vue'
import BaseCheckbox from '@/components/base/forms/BaseCheckbox'
import ImagesTransition from '@/components/utils/ImagesTransition'
import HealthyHabitsForm from '@/components/views/healthy-habits/HealthyHabitsForm'
import BaseDialog from '@/components/base/BaseDialog'
import { MICROHABIT_FOOD_TYPE } from '@/constants/microhabitTypes'
import MicrohabitsRepository from '@/repositories/MicrohabitsRepository'
import ArrowButton from '@/components/base/buttons/ArrowButton'

const COOKIE_FOOD_DETAILS_DIALOG = 'food-details-dialog'

export default {
	components: {
		BCarousel,
		BCarouselSlide,
		BIconHeart,
		BModal,
		BButton,
		BaseCheckbox,
		BIconHeartFill,
		ImagesTransition,
		HealthyHabitsForm,
		BIconChevronRight,
		BIconChevronLeft,
		BIconBell,
		BIconBellFill,
		BAlert,
		BBadge,
		BIconPlusCircle,
		BIconDashCircle,
		BaseDialog,
		ArrowButton
	},
	data () {
		return {
			COOKIE_FOOD_DETAILS_DIALOG,
			food: null,
			patientFood: {},
			newPatientFood: {
				createHabit: false,
				inDiet: false,
				habitId: null
			},
			addPatientFoodModalVisible: false,
			deletePatientFoodModalVisible: false,
			deleteAlsoFromHabits: false,
			showFoodDetailsDialog: true
		}
	},
	methods: {
		onHeartIconClick () {
			if (!this.$store.getters['session/userHasCompanies']) {
				this.$store.dispatch('showOnlySubscriptorsDialog')
				return
			}
			if (this.foodIsInPatientFoods) {
				this.deletePatientFoodModalVisible = true
			} else {
				this.addPatientFood()
				/* this.addPatientFoodModalVisible = true */
			}
		},
		onBellIconClick () {
			if (this.foodHasCreatedHabit) {
				this.$helpers.goToHabits()
			} else {
				this.newPatientFood.createHabit = true
				this.addPatientFoodModalVisible = true
			}
		},
		onPlusIconClick () {
			if (this.patientFood.inDiet) {
				this.removeFoodFromDiet()
			} else {
				this.addFoodToDiet()
			}
		},
		addPatientFood () {
			this.newPatientFood.microhabitId = this.food.id
			this.newPatientFood.microhabitCategoryId = this.$route.params.category
			this.repository.addPatientMicrohabit(this.newPatientFood).then((response) => {
				this.addPatientFoodModalVisible = false
				this.patientFood = this.newPatientFood
				this.patientFood.id = response.data
				this.newPatientFood = {}
				this.$store.dispatch('showAlert', {text: this.$t('patient.foods.patient-food-add-success'), variant: 'success'})
			})
		},
		deleteFoodFromPatientFoods () {
			this.repository.deletePatientMicrohabit(this.patientFood.id, this.deleteAlsoFromHabits).then(() => {
				this.patientFood = {}
				this.deletePatientFoodModalVisible = false
				this.$store.dispatch('showAlert', {text: this.$t('patient.foods.patient-food-delete-success'), variant: 'success'})
			})
		},
		removeFoodFromDiet () {
			this.patientFood.inDiet = false
			this.repository.updatePatientMicrohabit(this.patientFood).then(() => {
				this.deletePatientFoodModalVisible = false
				this.$store.dispatch('showAlert', {text: this.$t('patient.foods.patient-food-remove-diet-success'), variant: 'success'})
			})
		},
		onNewHabitCreated (habitId) {
			if (this.foodIsInPatientFoods) {
				this.patientFood.habitId = habitId
				this.repository.updatePatientMicrohabit(this.patientFood).then(() => {
					this.$store.dispatch('showAlert', {text: this.$t('patient.foods.habit-created-success-on-modify'), variant: 'success'})
					this.addPatientFoodModalVisible = false
				})
			} else {
				this.newPatientFood.habitId = habitId
			}
		},
		goToSlide (direction = 1) {
			this.repository.getMicrohabits(this.$route.params.category).then((response) => {
				const foods = response.data
				const currentIndex = foods.findIndex(food => food.id === this.food.id)
				let newIndex = currentIndex + direction
				if (newIndex === -1) {
					newIndex = foods.length - 1
				} else if (newIndex > (foods.length - 1)) {
					newIndex = 0
				}
				this.$router.push({name: 'FoodDetail', params: {category: this.$route.params.category, food: foods[newIndex].id}})
			})
		},
		addFoodToDiet () {
			this.patientFood.inDiet = true
			this.repository.updatePatientMicrohabit(this.patientFood).then(() => {
				this.$store.dispatch('showAlert', {text: this.$t('patient.foods.patient-food-add-diet-success'), variant: 'success'})
			})
		}
	},
	computed: {
		getCurrentFoodDescription () {
			return this.food && this.food.categories ? this.food.categories.find(category => category.id === this.$route.params.category).description : null
		},
		addToFavoritesTooltip () {
			return !this.foodIsInPatientFoods ? this.$t('patient.foods.add-to-my-foods') : this.$t('patient.foods.remove-from-my-foods')
		},
		foodIsInPatientFoods () {
			return Object.keys(this.patientFood).length > 0
		},
		foodHasCreatedHabit () {
			return this.patientFood.habitId
		},
		heartIconComponentType () {
			return this.foodIsInPatientFoods ? 'BIconHeartFill' : 'BIconHeart'
		},
		bellIconComponentType () {
			return this.foodHasCreatedHabit ? 'BIconBellFill' : 'BIconBell'
		},
		plusIconComponentType () {
			return this.patientFood && this.patientFood.achieved ? 'BIconDashCircle' : 'BIconPlusCircle'
		},
		createHabitTooltip () {
			return this.foodHasCreatedHabit ? this.$t('patient.foods.go-to-habit') : this.$t('patient.foods.create-habit')
		},
		plusIconTooltip () {
			return this.patientFood.achieved ? this.$t('patient.foods.remove-from-diet') : this.$t('patient.foods.diet-question')
		},
		habitCreationVisible () {
			return this.newPatientFood && !this.newPatientFood.habitId
		},
		modalTitle () {
			return this.foodIsInPatientFoods ? this.$t('patient.foods.habits-question') : this.$t('patient.foods.add-to-my-foods')
		},
		repository () {
			return new MicrohabitsRepository(MICROHABIT_FOOD_TYPE)
		}
	},
	mounted () {
		this.repository.getMicrohabit(this.$route.params.food).then((response) => {
			this.food = response.data
			this.$store.commit('microhabits/setCurrentMicrohabit', this.food)
		})
		if (this.$store.getters['session/userHasCompanies']) {
			this.repository.getPatientMicrohabits(this.$route.params.category, this.$route.params.food).then((response) => {
				this.patientFood = (response.data && response.data[0]) ? response.data[0] : {}
			})
		}

		if (this.$route.query.reminder) {
			this.onBellIconClick()
		}
	}
}
</script>

<style lang="scss" scoped>
h3 {
	text-transform: uppercase;
}

/deep/ {
	#carousel-food {
		@include media(desktop) {
			width: 70%;
			height: 300px;
		}
		display: flex;
		margin: auto;
	}

	.food-slide img {
		width: 100%;
		object-fit: cover;
	}
}
.neu-card-food {
	background-color: $white;
	border-radius: $border-radius;
	box-shadow: $custom-shadow;
	padding: 2rem;
	margin-top: 20px;
}

@mixin absolute-icon() {
	position: absolute;
	top: 2rem;
	cursor: pointer;
	font-size: 2rem;
}

.heart-food {
	@include absolute-icon;
	right: 2rem;
}

.bell-food {
	@include absolute-icon;
	left: 2rem;
}

.add-to-diet {
	@include absolute-icon;
	right: 6rem;
}

.chevron-icons {
	cursor: pointer;
	position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/foods/FoodDetail.vue